import { EyeIcon } from '@heroicons/react/24/solid'
import { Input, Textarea } from "@/components/ui"
import { useMandatForm } from './MandatFormContext'
import Contact from "../biens/Contact"
import EmptyValuePlaceholder from '../../components/ui/EmptyValuePlaceholder'

export default () => {
  // Récupérer les valeurs du contexte
  const { mandat, control, hasError, getErrorMessage } = useMandatForm()

  const handleDownload = (file) => {
    window.open(mandat[file].url, '_blank')
  }

  return (
    <div className={`grid grid-cols-1 md:grid-cols-3 gap-4`}>
      <div className="flex flex-col items-center gap-4">  
        <div className="w-full">
          <label className="label">
            <span className="label-text font-semibold">Propriétaires signataires</span>
          </label>
          <div className="space-y-2">
            { mandat.proprietaires_signataires?.length > 0 && mandat.proprietaires_signataires.map((proprietaire, index) => (
              <Contact key={proprietaire.id} label="Propriétaire" item={proprietaire} index={index} />
            ))}
          </div>
        </div>
      </div>

      <div className="flex flex-col items-start gap-4">  
        <Input.Date 
          name="date_fin"
          control={control}
          label="Date de fin du mandat"
          validator={{hasError, getErrorMessage}}
        />

        <Input.Text
          name="raison_fin"
          control={control}
          label="Raison de départ"
        />

        { mandat.mandat_file ?
          <Input.DisplayFile label="Mandat" title="le mandat" item={mandat} name="mandat_file" /> :
          <Input.Display label="Mandat" />
        }
      </div>

      <div className="flex flex-col items-center gap-4"> 
        <Textarea.Form control={control}
          name="details_fin"
          label="Précisez"
        />
      </div>
    </div>
  )
}